
export default {
  version: "1.0.6",
  date: "March 2026",
  NotesComponent: () => (
    <ul className="pl-8 pr-8 list-disc list-inside text-left text-sm max-h-[450px] overflow-y-auto space-y-1">
      <li>Added new Pomodoro Timer tool.</li>
      <li>Added new File Drop tool.</li>
      <li>Optimized preset loading.</li>
      <li>Optimized system stats tool.</li>
      <li>Updated <a href="https://toolip.app/policies" style={{textDecoration: 'underline'}}>privacy policy</a></li>
    </ul>
  ),
};
